import { render, staticRenderFns } from "./LegacyJob.vue?vue&type=template&id=6bb796f4&"
import script from "./LegacyJob.vue?vue&type=script&lang=js&"
export * from "./LegacyJob.vue?vue&type=script&lang=js&"
import style0 from "./LegacyJob.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MailtoButton: require('/app/components/MailtoButton.vue').default})
